<script setup>
import { ref, computed } from 'vue';
import { useShortLinkShare } from '~/composables/useShortLinkShare';

const props = defineProps({
  inviteUrl: {
    type: String,
    required: true
  },
  memberName: {
    type: String,
    default: ''
  },
  shareMessage: {
    type: String,
    default: null
  }
});

const { setAlertMessage } = useAlertService();

const {
  copyToClipboard,
  getSocialShareUrls,
  openShareWindow
} = useShortLinkShare();

const copied = ref(false);

const socialUrls = computed(() => {
  if (!props.inviteUrl) return null;

  const defaultMessage = props.memberName
    ? `Join ${props.memberName} on Tap Leagues!`
    : 'Join Tap Leagues!';

  return getSocialShareUrls(
    props.inviteUrl,
    props.shareMessage || defaultMessage
  );
});

const handleCopy = async () => {
  if (!props.inviteUrl) return;

  const success = await copyToClipboard(props.inviteUrl);

  if (success) {
    copied.value = true;
    setTimeout(() => {
      copied.value = false;
    }, 3000);
  } else {
    setAlertMessage({
      message: 'Failed to copy link',
      color: 'error',
      location: 'bottom'
    });
  }
};

const handleSocialShare = (platform) => {
  if (!socialUrls.value) return;

  const url = socialUrls.value[platform];
  if (url) {
    openShareWindow(url);
  }
};
</script>

<template>
  <div class="text-center">
    <div v-if="memberName" class="pa-4" style="font-size: 16px;">
      Share this invite link with <strong>{{ memberName }}</strong> so they can access their account:
    </div>
    <div v-else class="pa-4" style="font-size: 16px;">
      Share this invite link:
    </div>

    <div class="pa-4">
      <div class="tl-label mb-2">Invite link</div>
      <div class="tl-card pa-3 d-inline-block" style="font-size: 15px; word-break: break-all;">{{ inviteUrl }}</div>
    </div>

    <div class="pa-4">
      <v-btn
        class="mr-2"
        icon="mdi-content-copy"
        color="textSubtle"
        variant="outlined"
        size="small"
        @click="handleCopy"
      ></v-btn>
      <v-btn
        variant="outlined"
        color="textSubtle"
        class="mr-2"
        size="small"
        icon="mdi-whatsapp"
        @click="handleSocialShare('whatsapp')"
      >
      </v-btn>
      <v-btn
        size="small"
        variant="outlined"
        color="textSubtle"
        icon="mdi-email"
        @click="handleSocialShare('email')"
      >
      </v-btn>
    </div>

    <div v-if="copied" class="text-caption text-success mt-2">
      <v-icon size="small" class="mr-1">mdi-check</v-icon>
      Link copied to clipboard!
    </div>
  </div>
</template>

<style scoped>
</style>
